module.exports = __webpack_public_path__ + "static/media/ind2.599f3158.svg";